import React from 'react';
import { Box } from '@mui/material';

interface PageHeaderProps {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

// Page title block: optional small line above, 26px title, muted subtitle, right-aligned actions.
export const PageHeader = ({ eyebrow, title, subtitle, actions }: PageHeaderProps) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'flex-end', justifyContent: 'space-between' }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
      {eyebrow && <Box sx={{ fontSize: 13, color: 'var(--muted)' }}>{eyebrow}</Box>}
      <Box component="h1" sx={{ m: 0, fontSize: 26, fontWeight: 600, letterSpacing: '-0.025em', lineHeight: 1.2 }}>
        {title}
      </Box>
      {subtitle && <Box sx={{ fontSize: 14, color: 'var(--muted)' }}>{subtitle}</Box>}
    </Box>
    {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
  </Box>
);
